/** A bulk job's progress, where a list's selection bar stands while it runs: "Archiving 1,500 of 5,589…" and a bar. */
import type { Job } from "../api/types.gen.ts";
import { t } from "../i18n/index.ts";

const PERCENT = 100;

export function JobProgress({ job }: { job: Job }) {
  const share = job.total > 0 ? Math.round((job.done / job.total) * PERCENT) : 0;
  const text = t(`jobs.running.${job.action}`, { done: job.done, total: job.total });
  return (
    <div role="status" class="ml-auto flex min-h-8 items-center gap-3 text-sm text-zinc-700 tabular-nums">
      <span>{text}</span>
      <span
        role="progressbar"
        aria-label={text}
        aria-valuemin={0}
        aria-valuemax={PERCENT}
        aria-valuenow={share}
        class="h-1.5 w-24 overflow-hidden rounded-full bg-zinc-200"
      >
        <span class="block h-full rounded-full bg-blue-600 transition-[width]" style={{ width: `${share}%` }} />
      </span>
    </div>
  );
}
